import { Button } from "@/components/ui/button";
import { MessageCircle, MapPin, Phone, Mail } from "lucide-react";
import { trackWorkingLead } from "@/lib/utils";

const Contact = () => {
  const whatsappUrl = "https://api.whatsapp.com/send?phone=+5511963140057&text=Vim%20pelo%20site%20e%20quero%20agendar%20minha%20consulta.";
  
  const handleWhatsAppClick = () => {
    trackWorkingLead();
  };
  return <section id="contato" className="py-6 sm:py-8 lg:py-10 bg-background relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-secondary/30 to-background" />
      <div className="absolute top-0 left-0 w-[700px] h-[700px] bg-gradient-blue opacity-5 blur-[120px] rounded-full" />
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Title and Description */}
        <div className="text-center space-y-6 mb-16 animate-fade-in">
          <div className="space-y-4">
            <p className="text-accent font-inter text-sm uppercase tracking-wider inline-block px-4 py-2 rounded-full border border-accent/30 bg-accent/5">
              Entre em Contato
            </p>
            <h2 className="font-kiona text-4xl md:text-5xl lg:text-6xl font-bold text-foreground">
              Agende sua Consulta
            </h2>
          </div>

          <p className="text-muted-foreground font-inter text-lg leading-relaxed max-w-3xl mx-auto">
            Entre em contato e agende sua consulta com a Dra. Natália Piller
          </p>
        </div>

        {/* Grid with Map and Contact Info */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-start">
          {/* Google Maps */}
          <div className="animate-fade-in">
            <div className="relative w-full h-[350px] md:h-[450px] lg:h-[500px] rounded-2xl overflow-hidden shadow-blue border border-border/30">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.5851673925447!2d-46.57564492442987!3d-23.554448061513576!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce5ed3a1f9f4f9%3A0x7e8e8e8e8e8e8e8e!2sRua%20Itapura%2C%20239%20-%20Tatuap%C3%A9%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2003310-000!5e0!3m2!1spt-BR!2sbr!4v1234567890123!5m2!1spt-BR!2sbr" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }}
                allowFullScreen 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização Consultório Dra. Natália Piller - Rua Itapura, 239, Sala 401, Tatuapé"
              />
            </div>
          </div>

          {/* Contact Information */}
          <div className="space-y-4 animate-slide-in-left">

            <div className="space-y-4">
              <div className="flex items-center gap-4 p-4 rounded-xl bg-card border border-border hover:border-accent/30 transition-all hover-lift">
                <div className="w-14 h-14 rounded-full bg-gradient-blue flex items-center justify-center shadow-blue flex-shrink-0">
                  <Phone className="w-6 h-6 text-primary-foreground" />
                </div>
                <div>
                  <p className="font-inter text-sm text-accent mb-1">Telefones</p>
                  <p className="font-semibold text-foreground text-lg">(11) 96314-0057</p>
                  <p className="font-semibold text-foreground text-base">(11) 98567-7558</p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 rounded-xl bg-card border border-border hover:border-accent/30 transition-all hover-lift">
                <div className="w-14 h-14 rounded-full bg-gradient-blue flex items-center justify-center shadow-blue flex-shrink-0">
                  <MapPin className="w-6 h-6 text-primary-foreground" />
                </div>
                <div>
                  <p className="font-inter text-sm text-accent mb-1">Endereço</p>
                  <p className="font-semibold text-foreground text-lg">Rua Itapura, 239 – Sala 401</p>
                  <p className="font-semibold text-foreground text-base">Tatuapé – São Paulo/SP</p>
                  <p className="text-muted-foreground text-sm mt-1">CEP: 03310-000</p>
                  <p className="text-muted-foreground text-sm">Segunda a Sexta, das 9h às 18h</p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 rounded-xl bg-card border border-border hover:border-accent/30 transition-all hover-lift">
                <div className="w-14 h-14 rounded-full bg-gradient-blue flex items-center justify-center shadow-blue flex-shrink-0">
                  <MessageCircle className="w-6 h-6 text-primary-foreground" />
                </div>
                <div>
                  <p className="font-inter text-sm text-accent mb-1">WhatsApp</p>
                  <p className="font-semibold text-foreground text-lg">(11) 96314-0057</p>
                </div>
              </div>
            </div>

            <div className="flex justify-center lg:justify-start pt-4">
              <Button 
                size="lg" 
                className="hover-lift shadow-gold bg-accent hover:bg-accent/90 text-xs sm:text-sm font-medium h-10 sm:h-12 px-5 sm:px-6 w-full sm:w-auto max-w-xs sm:max-w-none" 
                asChild
              >
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" onClick={handleWhatsAppClick}>
                  <MessageCircle className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                  Agendar pelo WhatsApp
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Contact;